import { render } from "./AuthLayout.vue?vue&type=template&id=10e78dca&scoped=true"
const script = {}

import "./AuthLayout.vue?vue&type=style&index=0&id=10e78dca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e78dca"]])

export default __exports__